import { 
    LOAD_EVENT_LOG_DATA_IN_PROGRESS,
    LOAD_EVENT_LOG_DATA_SUCCESS,
    LOAD_EVENT_LOG_DATA_FAILURE,
    EVENT_LOG_OPERATION_COMPLETED,
  } from "./actions";
  
    const initialState = { isLoading: false, eventLogFilesList: []};
  
    export const eventLogFiles = (state = initialState, action) => {
        const { type, payload } = action;
        switch (type) {
            case LOAD_EVENT_LOG_DATA_SUCCESS: {
                const { data } = payload;
                return {
                    ...state,
                    isLoading: false,
                    eventLogFilesList: data,
                };
            }     
            case LOAD_EVENT_LOG_DATA_IN_PROGRESS:
            return {
                ...state,
                isLoading: true,
            };
            case LOAD_EVENT_LOG_DATA_FAILURE:
            return {
                ...state,
                isLoading: false,
            };

            case EVENT_LOG_OPERATION_COMPLETED:
            return {
                ...state,
                isLoading: false,
            }; 
            default:
                return state;
        }
    };
  